import { CALENDAR_YEAR } from '@/lib/config';
import { getMonthName } from '@/lib/constants';
import { uiFb, getTemplateStr } from '@/lib/i18n';

const YEAR = CALENDAR_YEAR;

interface BestMatchCalloutProps {
  month: number;
  holidayNames: string[];
  dm: { seasonName: string; weatherScore: number; crowdLevel: string; priceLevel: string };
  destinationName: string;
  lang: string;
}

export function BestMatchCallout({ month, holidayNames, dm, destinationName, lang }: BestMatchCalloutProps) {
  return (
    <div className="mb-8 rounded-lg border-2 border-accent-primary/30 bg-accent-primary/5 p-4">
      <div className="text-xs font-medium uppercase tracking-wider text-accent-primary">{uiFb('ui.best_match', 'Best Match', lang)}</div>
      <div className="mt-1 text-lg font-bold text-text-primary">
        {getMonthName(month - 1, lang)} {YEAR}
      </div>
      <p className="mt-1 text-sm text-text-secondary">
        {getTemplateStr('seo.cross.best_match_body', lang, {
          holidays: holidayNames.join(', '),
          season: dm.seasonName,
          destination: destinationName,
          weather: String(dm.weatherScore),
          crowds: dm.crowdLevel,
          prices: dm.priceLevel,
        })}
      </p>
    </div>
  );
}
